module.exports = __webpack_public_path__ + "static/media/blog-post.1.cb471b9e.md";